import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/DeletedMemberModal';

export const DELETED_MEMBER_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const DELETED_MEMBER_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
export const DELETED_MEMBER_MODAL_CLEAR = `${rootActionPath}/CLEAR`;
